import { render, staticRenderFns } from "./file-pres-added-attached.vue?vue&type=template&id=60788387"
import script from "./file-pres-added-attached.vue?vue&type=script&lang=js"
export * from "./file-pres-added-attached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports